import React from 'react';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import CardDeck from 'react-bootstrap/CardDeck';

function Contact() {
  return (

    <section id="contact" style={{marginTop:50}}>
    <h1 style={{fontWeight: 'bold', color: '#0116D5'}}>Contact Me</h1>
    <Container style={{marginTop:50}}>
    <CardDeck>
  <Card style={{boxShadow: '0 12px 16px 0 #AED6F1,0 17px 50px 0 #AED6F1', borderRadius: 8, border: 'none'}}>
    <Card.Body>
      <Card.Title style={{fontWeight: 'bold'}}>Working Hours</Card.Title>
      <Card.Text style={{marginTop:25}}>
        <p>Mon to Fri : 11.00 AM to 07.00 PM</p>
        <p>Saturday : 11.00 AM to 03.00 PM</p>
      </Card.Text>
    </Card.Body>
  </Card>
  <Card style={{boxShadow: '0 12px 16px 0 #FEB1CC,0 17px 50px 0 #FEB1CC', borderRadius: 8, border: 'none'}}>
    <Card.Body>
      <Card.Title style={{fontWeight: 'bold'}}>Contact Details</Card.Title>
      <Card.Text style={{marginTop:25}}>
        <p><a href="tel:8910440741" style={{color: '#333', textDecoration: 'none'}}>+91 8910440741</a></p>
        <p><a href="mailto:ratulsarkar221998@gmail.com" style={{color: '#333', textDecoration: 'none'}}>ratulsarkar221998@gmail.com</a></p>
      </Card.Text>
    </Card.Body>
  </Card>
  <Card style={{boxShadow: '0 12px 16px 0 #A8EBDD,0 17px 50px 0 #A8EBDD', borderRadius: 8, border: 'none'}}>
    <Card.Body>
      <Card.Title style={{fontWeight: 'bold'}}>My Location</Card.Title>
      <Card.Text style={{marginTop:25}}>
        <p>Netaji Palli, Belonia,</p>
        <p>South Tripura, India, Pin - 799155</p>
      </Card.Text>
    </Card.Body>
  </Card>
</CardDeck>
</Container>
</section>
  )}


  export default Contact;
